/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { CoreErrorKey } from '../key/core-error.key';
import { ApplicationError } from '../model/application-error.model';
import { ObservableCollection } from '../util/observable-collection.util';

export function toValues<V>(
  source: Iterable<V> | Map<any, V> | ObservableCollection<any, V> | object
): Iterable<V> {
  if (source === undefined || source === null) {
    throw new ApplicationError({
      key: CoreErrorKey.SOURCE_MISSING,
      arguments: { source }
    });
  }
  if (typeof source !== 'object') {
    throw new ApplicationError({
      key: CoreErrorKey.SOURCE_INVALID,
      arguments: { source }
    });
  }
  // if (Array.isArray(source) || source instanceof Map || source instanceof ObservableCollection) {
  //   return source.values();
  // }
  if (typeof source['values'] === 'function') {
    return source['values']() as Iterable<V>;
  }
  if (source[Symbol.iterator]) {
    return source as Iterable<V>;
  }
  // Object.values is not supported by IE 11
  const values: Array<any> = typeof Object.values === 'function'
    ? Object.values(source)
    : Object.keys(source).map((key) => source[key]);
  return values[Symbol.iterator]();
}
